import { Buffer } from 'buffer';

export function createBlobFromResponse(data, contentType = 'application/octet-stream') {

    console.log('createBlobFromResponse', data, contentType);

    if (typeof data === 'string') {

        let buffer;

        // Base64-encoded Data URL
        if (data.startsWith('data:')) {
            const [meta, base64Data] = data.split(',');
            if (!base64Data) {
                throw new Error('Malformed data URL: missing base64 content');
            }

            const mimeMatch = meta.match(/data:(.*);base64/);
            contentType = mimeMatch ? mimeMatch[1] : contentType;

            buffer = Buffer.from(base64Data, 'base64');
        } else if (isBase64(data)) {
            buffer = Buffer.from(data, 'base64');
        } else {
            buffer = Buffer.from(data, 'latin1'); // latin1 preserves byte values
        }

        return new Blob([buffer], { type: contentType });
    }

    if (Buffer.isBuffer(data)) {
        return new Blob([data], { type: contentType });
    }

    // Serialized Buffer objects with nested data array
    if (isSerializedBuffer(data)) {
        console.log('Converting serialized Buffer to Buffer, length:', data.data.length);
        const buffer = Buffer.from(data.data);
        return new Blob([buffer], { type: contentType });
    }

    // Direct numeric arrays
    if (Array.isArray(data) && data.length > 0 && typeof data[0] === 'number') {
        console.log('Converting numeric array to Buffer, length:', data.length);
        const buffer = Buffer.from(data);
        return new Blob([buffer], { type: contentType });
    }

    if (data instanceof ArrayBuffer || data instanceof Uint8Array) {
        return new Blob([data], { type: contentType });
    }

    if (typeof Blob !== 'undefined' && data instanceof Blob) {
        return data;
    }

    throw new Error("Unsupported data type for Blob creation.");
}

function isSerializedBuffer(data) {
    return (
        data &&
        typeof data === 'object' &&
        data.type === 'Buffer' &&
        Array.isArray(data.data) &&
        data.data.length > 0 &&
        typeof data.data[0] === 'number'
    );
}

function isBase64(str) {
    try {
        return Buffer.from(str, 'base64').toString('base64') === str;
    } catch (err) {
        return false;
    }
}
